module.exports = __webpack_public_path__ + "img/ic_item_gk_default.ce481619.png";